/**
 * External Dependencies
 */
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import googleCalendarPlugin from '@fullcalendar/google-calendar';
import listPlugin from '@fullcalendar/list';


document.addEventListener('DOMContentLoaded', function() {
	let calendarEl = document.getElementById('pi_calendar');
	let calendar = new Calendar(calendarEl, {
		plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, googleCalendarPlugin ],
		initialView: 'dayGridMonth',
		googleCalendarApiKey: 'AIzaSyCSG1YcRcMdiOG0NdDBuLNj8Lx98q54cdo',
		height: 'auto',
		locale: 'cs',
		firstDay: 1,
		headerToolbar: {
			left: 'title',
			center: 'prev,next',
			right: null
		},
		eventBackgroundColor: '#111827',
		eventColor: 'white',
		events: {
			googleCalendarId: 'jj8iqpr2jg2upf8nantfke8q48@group.calendar.google.com',
		},
		eventClick: function(info) {
			info.jsEvent.preventDefault(); // don't let the browser navigate
		},
	});

	calendar.render();

	let eventsEl = document.getElementById('pi_events');
	let events = new Calendar(eventsEl, {
		plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, googleCalendarPlugin ],
		initialView: 'listYear',
		googleCalendarApiKey: 'AIzaSyCSG1YcRcMdiOG0NdDBuLNj8Lx98q54cdo',
		height: 'auto',
		locale: 'cs',
		headerToolbar: false,
		events: {
			googleCalendarId: 'jj8iqpr2jg2upf8nantfke8q48@group.calendar.google.com',
		},
		eventClick: function(info) {
			info.jsEvent.preventDefault(); // don't let the browser navigate
		},
		eventDidMount:function(info){
			let element   = info.el;
			let location  = info.event.extendedProps.location;
			let title   = info.event.title;
			element.querySelector('.fc-list-event-title').innerHTML = title + '<br>' + location;
		}
	});

	events.render();
});
